import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import { PageHeader } from "@/widgets/page-header"
import { fetchTradingPartner, selectSocialMarketPartner, selectSocialMarketPartnerLoading } from "../model"
import { Loader } from "@/shared/ui/loader"
import { PageSubtitle } from "@/shared/ui/page-subtitle"
import { useEffect } from "react"
import { useNavigate, useParams } from "react-router-dom"
import ArrowRightUpSvg from '@/shared/assets/images/ArrowUpRight.svg'

export const SocialMarketPartnerPage = () => {
    const { id } = useParams()
    const dispatch = useAppDispatch()
    const partner = useAppSelector(selectSocialMarketPartner)
    const partnerLoading = useAppSelector(selectSocialMarketPartnerLoading)
    const navigate = useNavigate()

    useEffect(() => {
        if (id !== partner.id) {
            dispatch(fetchTradingPartner(id))
            .unwrap()
            .catch(() => {
                navigate('/404', { replace: true })
            })
        }
    }, [])

    return (
        <div className="_page_container flex-1">
            <PageHeader title="Маркет социальных программ" />
            {partnerLoading &&
                <Loader />
            }
            {(partner && !partnerLoading) &&
                <div className='flexbox h-full'>
                    <PageSubtitle title={(
                        <div className="text-nowrap overflow-ellipsis overflow-hidden">
                            {partner.name}
                        </div>
                    )} />
                    <div className="px-6 py-3 gap-[20px] flex flex-col border border-[#EAECF0] rounded-2xl">
                        <div className="h-[240px] border w-[340px] rounded-[12px] overflow-hidden">
                            <img src={partner.logo} alt="" className="w-full h-full object-cover" />
                        </div>
                        <div className="flex gap-[10px]">
                            <div className="text-2xl screen:max-w-[50%] font-semibold text-nowrap overflow-hidden text-ellipsis">
                                {partner.name}
                            </div>
                            <div className="text-color-primary font-semibold shrink-0 flex items-end">
                                <a href={partner.href} target="_blank" className="inline-flex gap-2">
                                    Перейти на сайт <ArrowRightUpSvg width={24} height={24} />
                                </a>
                            </div>
                        </div>
                        <div className="text-base screen:max-w-[60%] font-normal text-[#535862]">
                            {partner.description}
                        </div>
                    </div>
                </div>
            }
        </div>
    )
 }